import Cart from "./Cart.view";

export default Cart;
